<label class="label" [attr.data-size]="size" [attr.data-layout]="layout" [attr.data-weight]="weight"
    [attr.data-required]="required" [attr.data-disabled]="disabled" [attr.data-error]="error" [attr.for]="htmlFor">

    <!-- Label text -->
    <span class="label-text">{{ text }}</span>

    <!-- Required indicator -->
    <span *ngIf="required" class="required-indicator" aria-hidden="true">*</span>

</label>